import './assets/main.css'
import { createApp } from 'vue'
import App from './App.vue'
import { setupI18n } from './locales/setup'
import TDesign from 'tdesign-vue-next'
import 'tdesign-vue-next/es/style/index.css'
import './styles/theme.less'
import './styles/global.less'
import './styles/fix.less'
import { store } from './store'
import { setupRouter } from './router'
import { VueQueryPlugin } from '@tanstack/vue-query'
import './microApp'
import tIcon from 'tdesign-icons-vue-next'
import type { VueQueryPluginOptions } from '@tanstack/vue-query'
import { setupCustomComponent } from './components'

const vueQueryPluginOptions: VueQueryPluginOptions = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        retry: false
      }
    }
  }
}

const setup = async () => {
  const app = createApp(App)

  tIcon.install(app)

  await setupI18n(app)

  app.use(TDesign as any)
  app.use(store)
  app.use(VueQueryPlugin, vueQueryPluginOptions)
  setupCustomComponent(app)
  setupRouter(app)
  app.mount('#app')
}

setup()
